import { Box } from "@mui/material";
import * as styles from "./styles";

const WelcomeLoader = () => {
  return (
    <Box display="flex" flex="1 1" sx={styles.container}>
      {/* <img
        src={require("@assets/gifs/welcomeLoading.gif")}
        width="120"
        alt="Reservation"
      /> */}
      <img src={require("@assets/images/logo.png")} alt="loading" width="120" />
    </Box>
  );
};

export default WelcomeLoader;
